import "./PhotoCarousel.css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { assetUrl } from "../../wordpress";

const photos = [
	"/assets/pics/b_c1.png",
	"/assets/pics/b_c3.png",
	"/assets/pics/b_cta.png",
	"/assets/pics/b_eixo2.png",
	"/assets/pics/b_eixo3.png",
	"/assets/pics/b_v2.png",
	"/assets/pics/b_v3.png",
	"/assets/hero.webp",
	"/assets/pics/cadaques01.png",
	"/assets/pics/cadaques02.png",
	"/assets/pics/cadaques03.png",
	"/assets/pics/cadaques04.png",
	"/assets/pics/cadaques05.png",
	"/assets/pics/cadaques10.png",
	"/assets/pics/cadaques11.png",
	"/assets/pics/cadaques12.png",
	"/assets/pics/cadaques13.png",
	"/assets/pics/cadaques20.png",
	"/assets/pics/cadaques21.png",
	"/assets/pics/cadaques22.png",
];

export function PhotoCarousel() {
	return (
		<Splide
			className="photo-carousel"
			aria-label="Fotografias da CosaNova"
			extensions={{ AutoScroll }}
			options={{
				type: "loop",
				perPage: 1,
				autoWidth: true,
				gap: "clamp(12px, 1.5vw, 22px)",
				arrows: false,
				pagination: false,
				drag: false,
				autoScroll: {
					speed: 0.55,
					pauseOnHover: true,
					pauseOnFocus: false,
				},
			}}
		>
			{photos.map((src) => (
				<SplideSlide key={src}>
					<figure className="photo-carousel__card">
						<img src={assetUrl(src)} alt="" />
						<img
							className="photo-carousel__mark"
							src={assetUrl("/assets/CosanovaStar.png")}
							alt=""
							aria-hidden="true"
						/>
					</figure>
				</SplideSlide>
			))}
		</Splide>
	);
}
